import * as React from 'react';
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { addFootnoteReference, removeFootnoteReference } from '../state/actions';
import { useFootnoteReferenceDispatch, useFootnoteReferenceState } from '../..';
const FootnoteSpan = styled.span `
  font-weight: var(${(props) => { var _a, _b; return ((_b = (_a = props === null || props === void 0 ? void 0 : props.theme) === null || _a === void 0 ? void 0 : _a.fontWeights) === null || _b === void 0 ? void 0 : _b.bold) || 'bold'; }});
  cursor: pointer;
  border-bottom: 0 !important;
  vertical-align: text-top;
  line-height: 1;
  & a {
    text-decoration: none !important;
    color: inherit !important;
  }
`;
const FootnoteLink = styled.a `
  border-bottom: 0 !important;
  line-height: 1;
  text-decoration: none !important;
  font-weight: inherit !important;
  color: inherit !important;
  font-size: var(
    ${(props) => { var _a, _b, _c, _d; return ((_d = (_c = (_b = (_a = props.theme) === null || _a === void 0 ? void 0 : _a.responsive) === null || _b === void 0 ? void 0 : _b.typography) === null || _c === void 0 ? void 0 : _c.copy1) === null || _d === void 0 ? void 0 : _d.fontSize) || '16px'; }}
  ) !important;
  vertical-align: text-top;
`;
export const FootnoteLinkSup = styled.sup `
  vertical-align: super;
  top: 0;
  font-size: 0.583em;
`;
export const FootnoteReference = ({ refId, useSpan }) => {
    if (!refId) {
        return null;
    }
    const { references } = useFootnoteReferenceState();
    const dispatch = useFootnoteReferenceDispatch();
    const [referenceNumber, setReferenceNumber] = useState(null);
    const [referenceContextId, setReferenceContextId] = useState('');
    useEffect(() => {
        dispatch(addFootnoteReference(refId));
        return () => {
            dispatch(removeFootnoteReference(refId));
        };
    }, [dispatch]);
    useEffect(() => {
        const reference = references.find((ref) => ref.id === refId);
        const refNumber = reference === null || reference === void 0 ? void 0 : reference.number;
        const contextId = reference === null || reference === void 0 ? void 0 : reference.contextId;
        setReferenceContextId(contextId);
        if (refNumber && refNumber > 0) {
            setReferenceNumber(refNumber);
        }
    }, [references]);
    const scrollToRef = (evt) => {
        var _a;
        evt.preventDefault();
        (_a = document.querySelector(`#${referenceContextId}`)) === null || _a === void 0 ? void 0 : _a.scrollIntoView({ behavior: 'smooth' });
    };
    if (useSpan) {
        return (React.createElement("span", { translate: "no" },
            React.createElement(FootnoteSpan, { className: "audi-j-footnote-reference" },
                React.createElement(FootnoteLinkSup, { className: "audi-footnote-anchor__text" },
                    React.createElement("a", { href: `#${referenceContextId || refId}`, onClick: scrollToRef, "aria-label": `Footnote ${referenceNumber || ''}` }, typeof referenceNumber === 'number' && referenceNumber > 0 ? referenceNumber : '')))));
    }
    return (React.createElement("span", { translate: "no" },
        React.createElement(FootnoteLink, { className: "audi-j-footnote-reference", href: `#${referenceContextId || refId}`, onClick: scrollToRef, "aria-label": `Footnote ${referenceNumber || ''}` },
            React.createElement(FootnoteLinkSup, { className: "audi-footnote-anchor__text" }, typeof referenceNumber === 'number' && referenceNumber > 0 ? referenceNumber : ''))));
};
export const footnoteRegEx = /(\{\{ft_[-a-zA-Z0-9_]+}})/g;
export const PlainTextWithFootnotes = ({ text, useSpan, }) => {
    if (!text) {
        return null;
    }
    const parts = text.split(footnoteRegEx);
    return (React.createElement(React.Fragment, null, parts.map((part) => {
        const match = part.match(/(\{\{(ft_[-a-zA-Z0-9_]+)}})/);
        const refId = match === null || match === void 0 ? void 0 : match[2];
        if (refId) {
            return React.createElement(FootnoteReference, { key: `${refId}`, refId: refId, useSpan: useSpan });
        }
        return part || null;
    })));
};
